import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LoginRequest } from "../../../api/requests/Api";
import { Credits } from "../../../entity/Entity";
import { setToken } from "../../../utils/Auth";
import "./Login.css";

const Login = () => {
    const [login, setLogin] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const navigate = useNavigate();

    const handleLogin = async () => {
        if (!login || !password) {
            setError("Login and password are required");
            return;
        }

        const credits: Credits = {
            login,
            password,
        };

        try {
            setLoading(true);
            setError(null);

            const token = await LoginRequest(credits);

            // store only access string
            setToken(token.access);

            navigate("/admin-oks/categories");
        } catch {
            setError("Invalid login or password");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-page">
            <div className="login-box">
                <h1>Login</h1>

                {error && <div className="login-error">{error}</div>}

                <input
                    type="text"
                    placeholder="Login"
                    value={login}
                    onChange={(e) => setLogin(e.target.value)}
                />

                <input
                    type="password"
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                />

                <button onClick={handleLogin} disabled={loading}>
                    {loading ? "Logging in..." : "Login"}
                </button>
            </div>
        </div>
    );
};

export default Login;
